// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "flickity" + "." + "d50edfd4850d1a396265" + ".js";
};